import * as React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Container, CloseButton, Detail } from './styled';
import { GlobalStyles } from '@/presentation/components/LightBox';
import closeIcon from '@/assets/icons/courses/AttendanceDetail/close-icon.svg';

interface DrawerProps {
  title: string;
  closeHandler: () => void;
}
const Drawer: React.FC<DrawerProps> = ({ children, title, closeHandler }) => (
  <div
    className="animate__animated animate__fadeIn animate__faster"
    style={{
      background: 'rgb(40 48 68 / 60%)',
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: 99,
      height: '100%'
    }}
  >
    <OutsideClickHandler onOutsideClick={closeHandler}>
      <Container
        data-testid="cmp-attendance-detail"
        className="animate__animated animate__fadeIn animate__faster"
      >
        <GlobalStyles />
        <CloseButton>
          <button
            type="button"
            data-testid="closeIcon"
            className="closeIcon"
            onClick={closeHandler}
          >
            <img src={closeIcon} alt="close" />
          </button>
        </CloseButton>
        <Detail>
          <div className="title" style={{ fontSize: 20 }}>
            {title}
          </div>
          {children}
        </Detail>
      </Container>
    </OutsideClickHandler>
  </div>
);

export default Drawer;
